import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import LongText from '../Elements/LongText';
import LookupText from '../Elements/LookupText';

export default class ClientInvoiceLineItem {
  constructor(item) {
    if (item === undefined) {
      this.LineItemId = '';
      this.Name = '';
      this.AdHocGroup = '';
      this.LineItemType = '';
      this.InitDue = '';
      this.Paid = '';
      this.LineItemCredit = '';
      this.Outstanding = '';
      this.OutstandingLineItemVatcurrency = '';
      this.OutstandingReimbLineItemCurrency = '';
      this.LineItemId = '';
      this.ClientInvoiceId = '';
      this.CurrencySymbol = '';
      this.CurrencyCode = '';
      this.ProjectId = '';
      this.ServiceId = '';
      this.OpportunityId = '';
      this.LineItemTypeId = '';
      this.InternalLineItemTypeId = '';
      this.LineItem = '';
      this.Selected = false;
    } else {
      this.LineItemId = item.lineItemId;
      this.Name = item.name;
      this.AdHocGroup = item.adHocGroup;
      this.LineItemType = item.lineItemType;
      this.InitDue = item.initDue;
      this.Paid = item.paid;
      this.LineItemCredit = item.lineItemCredit;
      this.Outstanding = item.outstanding;
      this.OutstandingLineItemVatcurrency = item.outstandingLineItemVatcurrency;
      this.OutstandingReimbLineItemCurrency = item.outstandingReimbLineItemCurrency;
      this.LineItemId = item.lineItemId;
      this.ClientInvoiceId = item.clientInvoiceId;
      this.CurrencySymbol = item.currencySymbol;
      this.CurrencyCode = item.currencyCode;
      this.ProjectId = item.projectId;
      this.ServiceId = item.serviceId;
      this.OpportunityId = item.opportunityId;
      this.LineItemTypeId = item.lineItemTypeId;
      this.InternalLineItemTypeId = item.internalLineItemTypeId;
      this.LineItem = item.lineItem;
      this.Selected = false;
    }
    this.Selected = false;
  }

  static MoneyFields = [
    'InitDue',
    'Paid',
    'Outstanding',
    'LineItemCredit',
    'OutstandingLineItemVatcurrency',
    'OutstandingReimbLineItemCurrency',
  ];
  static DateFields = [];

  static Currency() {
    return 'CurrencyCode';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: ClientInvoiceLineItem.getSelectedCellHeader,
        orderById: '',
        data: ClientInvoiceLineItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      { label: 'Name', orderById: 'Name', data: ClientInvoiceLineItem.getNameCellContent, minWidth: 40 },
      { label: 'Ad-Hoc Group', orderById: 'AdHocGroup', data: 'AdHocGroup', minWidth: 20 },
      { label: 'Type', orderById: 'LineItemType', data: 'LineItemType', minWidth: 20 },
      {
        // Not sortable: vZeusLineItemOpen does not carry the internal type, it is filled in per
        // page from the ClientLine rows behind the listed line items.
        label: 'Internal Type',
        orderById: '',
        data: (item) =>
          !item.InternalLineItemTypeId ? (
            ''
          ) : (
            <LookupText
              lookupId={42}
              value={item.InternalLineItemTypeId}
            />
          ),
        minWidth: 20,
      },
      { label: 'Initial Total', orderById: 'InitDue', data: 'InitDue', minWidth: 10 },
      { label: 'Paid', orderById: 'Paid', data: 'Paid', minWidth: 10 },
      { label: 'Credit', orderById: 'LineItemCredit', data: 'LineItemCredit', minWidth: 10 },
      { label: 'Outstanding', orderById: 'Outstanding', data: 'Outstanding', minWidth: 10 },
      {
        label: 'Fee Tax',
        orderById: 'OutstandingLineItemVatcurrency',
        data: 'OutstandingLineItemVatcurrency',
        minWidth: 10,
      },
      {
        label: 'Reimbursement Tax',
        orderById: 'OutstandingReimbLineItemCurrency',
        data: 'OutstandingReimbLineItemCurrency',
        minWidth: 10,
      },
      { label: 'Line Item ID', orderById: 'LineItemId', data: 'LineItemId', minWidth: 10 },
      { label: 'Client Invoice', orderById: 'ClientInvoiceId', data: 'ClientInvoiceId', minWidth: 10 },
      {
        label: ' ',
        orderById: '',
        data: ClientInvoiceLineItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getNameCellContent(item) {
    return (
      <LongText
        text={item.Name ? item.Name : ' '}
        maxLength={100}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={ClientInvoiceLineItem.selectedStatus()}
          onChange={(e) => {
            ClientInvoiceLineItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            ClientInvoiceLineItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static clickOnSelect(item, selected) {}

  static selectedStatus() {
    return false;
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            iconName: 'fa-solid fa-edit',
            roleKey: 'edit_invoicelineitem',
            onClick: () => ClientInvoiceLineItem.editFunction(item.CiId, item),
            disabled: ClientInvoiceLineItem.isDisabled(item),
          },
        ]}
      />
    );
  }

  static editFunction(id, item) {
    alert('Empty Function');
  }

  static isDisabled(item) {
    return true;
  }
}
